import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { IPolicy } from 'wz-types/pages-policies.d';
import { Globals } from '~shared/classes';
import { SeoService } from '~shared/services';

@Component({
  selector: 'wz-terms-of-service-page',
  templateUrl: './terms-of-service-page.component.html',
  styleUrls: ['./terms-of-service-page.component.scss']
})
export class TermsOfServicePageComponent implements OnInit {
  termsHtml: string;

  constructor(
    private http: HttpClient,
    private seoSrv: SeoService
  ) { }

  ngOnInit() {
    this.seoSrv.generateTags({ title: 'Terms of Service' });
    this.http.get(`${Globals.environment.apiUrl}pages-policies/termsOfService`).pipe(
      map((policy: IPolicy) => {
        this.termsHtml = policy.html;
      })
    ).subscribe();
  }

}
